import { gold } from '@ant-design/colors';
import { WarningTwoTone } from '@ant-design/icons';
import { List } from 'antd';
import type { NotificationInstance } from 'antd/es/notification/interface';
import { deCollator } from '../utils/collator';

export const showParamWarning = (notification: NotificationInstance, title: string, message: string, params: string[], key?: string) => {
  notification.open({
    title: (
      <>
        <WarningTwoTone twoToneColor={gold[5]} /> {title}
      </>
    ),
    duration: 8,
    key: key,
    description: (
      <>
        {message}
        <List
          size="small"
          itemLayout="horizontal"
          dataSource={[...params].sort(deCollator.compare)}
          renderItem={param => (
            <List.Item>
              <List.Item.Meta title={param} />
            </List.Item>
          )}
        />
      </>
    ),
  });
};
